import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const breadcrumbNames: Record<string, string> = {
    'dashboard': 'Dashboard',
    'pdv': 'PDV',
    'produtos': 'Produtos',
    'clientes': 'Clientes',
    'encomendas': 'Encomendas',
    'estoque': 'Estoque',
    'funcionarios': 'Funcionários',
    'relatorios': 'Relatórios',
    'fechamento-caixa': 'Fechamento de Caixa',
    'perfil': 'Perfil',
    'pedidos': 'Pedidos',
    'admin': 'Administração',
    'estabelecimentos': 'Estabelecimentos',
    'usuarios': 'Usuários',
  };

  if (pathnames.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-sm">
        <li>
          <Link
            to="/dashboard"
            className="flex items-center gap-1 text-neutral-600 hover:text-primary-600 transition-colors"
          >
            <Home className="w-4 h-4" />
            <span>Início</span>
          </Link>
        </li>

        {pathnames.map((path, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const label = breadcrumbNames[path] || path;

          return (
            <React.Fragment key={to}>
              <ChevronRight className="w-4 h-4 text-neutral-400" aria-hidden="true" />
              <li>
                {isLast ? (
                  <span className="font-medium text-neutral-900" aria-current="page">
                    {label}
                  </span>
                ) : (
                  <Link
                    to={to}
                    className="text-neutral-600 hover:text-primary-600 transition-colors"
                  >
                    {label}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
